import { MonthlyStatistics } from '@tassomutuo-backoffice/types';
import { Box, Typography } from '@mui/material';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import React from 'react';
import { format, parse } from 'date-fns';
import { it } from 'date-fns/locale';
import formatMoney from '../../../utils/formatMoney';

interface IProps {
  statisticsPerMonth: MonthlyStatistics;
  isPrinting?: boolean;
  reverse?: boolean;
  hideLostRevenue?: boolean;
}

const DashboardEffectiveRevenueChart = ({
  statisticsPerMonth,
  isPrinting,
  reverse = true,
  hideLostRevenue = false,
}: IProps) => {
  const chartData = Object.entries(statisticsPerMonth).map(
    ([month, stats]) => ({
      month,
      effectiveRevenue: stats.effectiveRevenue,
      lostRevenue: stats.lostRevenue,
    })
  );

  if (reverse) {
    chartData.reverse();
  }

  const customTooltipFormatter = (value: number, name: string) => {
    const formattedValue = formatMoney(value);
    if (name === 'effectiveRevenue') {
      return [formattedValue, 'Fatturato Effettivo'];
    }
    if (name === 'lostRevenue') {
      return [formattedValue, 'Fatturato Perso'];
    }
    return [formattedValue, name];
  };

  return (
    <Box
      sx={{
        backgroundColor: '#FAFAFA',
        padding: 4,
        mt: 6,
        borderRadius: '16px',
        border: '1px solid gainsboro',
      }}
    >
      <Typography variant="h4" mb={1} fontWeight="bold">
        Fatturato Totale
      </Typography>
      <Typography variant="h6" mb={4}>
        Fatturato totale effettivo secondo il periodo selezionato
      </Typography>
      <Box
        sx={{
          width: '100%',
          p: 2,
          height: 400,
          minWidth: isPrinting ? 1000 : undefined,
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            barCategoryGap={15}
            margin={{ left: 20, right: 150 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />

            <XAxis
              dataKey="month"
              tickFormatter={(month) => {
                const date = parse(month, 'MMMM yyyy', new Date(), {
                  locale: it,
                });
                return format(date, 'MMM yy', { locale: it });
              }}
            />
            <YAxis domain={[0, (dataMax: number) => Math.ceil(dataMax * 1.1)]} />
            <Tooltip
              formatter={customTooltipFormatter}
              cursor={{ fill: 'transparent' }}
            />
            <Bar
              barSize={80}
              dataKey="effectiveRevenue"
              name=""
              fill="rgba(59, 130, 246, 1)"
              activeBar={<Rectangle fill="rgba(16, 60, 85, 1)" />}
              stackId="a"
            />
            {!hideLostRevenue && (
              <Bar
                barSize={80}
                dataKey="lostRevenue"
                name=""
                fill="rgba(253, 106, 94, 1)"
                activeBar={<Rectangle fill="rgba(200, 60, 45, 1)" />}
                stackId="a"
              />
            )}
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default DashboardEffectiveRevenueChart;
